import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Tabela from "../../components/Tabela";
import { getTipo } from "../../api/tipoApi";
import { buscaTipo } from "../../types/tipo";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Tipo: React.FC = () => {
  const [tipo, setTipo] = useState<buscaTipo[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTipos = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const tipoData = await getTipo(token);
        setTipo(tipoData);
      } catch (error) {
        toast.error("Erro ao buscar tipos!");
        console.error("Erro ao buscar tipos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTipos();
  }, []);

  const handleAddTipo = () => {
    navigate("/adicionarTipo");
  };

  const handleEditTipo = (id: string) => {
    navigate(`/editarTipo/${id}`);
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "nome_tipo", label: "Tipos do Usuário" },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Tipos de Usuários"
        colunas={colunas}
        dados={tipo}
        onAdd={handleAddTipo}
        onEdit={handleEditTipo}
        loading={loading}
        showVisibilityIcon={false}
        onView={() => {}}
      />
    </Box>
  );
};

export default Tipo;
